import Component from "./PaymentsModal";

export default Component;
